module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"-1 3 50 50\" style=\"enable-background:new -1 3 50 50;\" xml:space=\"preserve\"><line class=\"st0\" x1=\"24\" y1=\"7.27\" x2=\"24\" y2=\"48.73\"></line><line class=\"st0\" x1=\"44.73\" y1=\"28\" x2=\"3.27\" y2=\"28\"></line></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphcool-styles/icons/stroke/addFull.svg
// module id = 569
// module chunks = 0 1